<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-4 md:px-6 lg:px-8">
    <div class="w-full pb-12">
      <router-view />
    </div>
  </div>
</template>
